<template>
  <div>
    <div class="w-full relative bottom-[10px] border-b dark:border-dark-divider-border" />
    <div
      class="w-10 cursor-pointer relative bottom-[25px] h-10 text-center items-center flex justify-center rounded-full border dark:border-dark-divider-border bg-white dark:bg-dark-box-background"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false">
      <div v-if="hovering">
        <ChevronUp class="h-5 w-5 text-gray-400 relative top-1" aria-hidden="true" />
        <ChevronDown class="h-5 w-5 text-gray-400 relative bottom-1" aria-hidden="true" />
      </div>
      <div v-else>
        {{ collapsedEmails }}
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronDown, ChevronUp } from "lucide-vue-next"
export default {
  components: { ChevronDown, ChevronUp },
  props: {
    collapsedEmails: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      hovering: false
    }
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
